module.exports = __webpack_public_path__ + "img/1289435444.bb9d0e10.jpg";